import { render, staticRenderFns } from "./business_card_set.vue?vue&type=template&id=1287d197&scoped=true&"
import script from "./business_card_set.vue?vue&type=script&lang=js&"
export * from "./business_card_set.vue?vue&type=script&lang=js&"
import style0 from "./business_card_set.vue?vue&type=style&index=0&id=1287d197&prod&lang=scss&scoped=true&"
import style1 from "./business_card_set.vue?vue&type=style&index=1&id=1287d197&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287d197",
  null
  
)

export default component.exports